import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { SessionService } from '../session/session.service';
import { ServicesModule } from '../services/services.module';
import { MaskActionComponent } from './components/mask-action/mask-action.component';
import { InactivityMonitorService } from './inactivity-monitor.service';
import { SessionMonitorService } from './session-monitor.service';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    // ButtonsModule
    ServicesModule.forRoot(),
  ],
  declarations: [MaskActionComponent],
})
export class SessionModule {
  static forRoot(): ModuleWithProviders<SessionModule> {
    return {
      ngModule: SessionModule,
      providers: [SessionMonitorService, InactivityMonitorService, SessionService],
    };
  }

  constructor(@Optional() @SkipSelf() servicesModule: SessionModule) {
    if (servicesModule) {
      throw new Error('SessionModule is already loaded. Import it in the AppModule only');
    }
  }
}
